import { AddLocationIcon, CalendarIcon, Icon, Pane, Tab, Tablist, TimeIcon } from 'evergreen-ui';
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import PanelExtraTime from './PanelExtraTime';
import PanelWorkingDays from './PanelWorkingDays';
import PanelWorkingHours from './PanelWorkingHours';

const icon = {
  calendar: CalendarIcon,
  time: TimeIcon,
  add: AddLocationIcon,
};
const tabs = ['calendar', 'time', 'add'];
const StyledTab = styled(Tab)`
  position: relative;
  border: none !important;
  z-index: 1;
  max-width: 72px;

  &:hover,
  &:active,
  &[aria-selected='true'] {
    background-color: #1f2021 !important;
  }

  &:focus {
    box-shadow: none;
  }

  &::before {
    content: '';
    position: absolute;
    background: #e78850;
    left: 24px;
    right: 24px;
    bottom: 8px;
    height: 4px;
    z-index: -1;
    opacity: 0;
    transition: opacity ease 0.2s;
  }
  &[aria-selected='true']::before {
    opacity: 1;
  }

  &:hover > div {
    color: #ffffff88;
  }
  &[aria-selected='true'] > div {
    color: #fff;
  }

  &:hover > div,
  &[aria-selected='true'] > div {
    &::before {
      content: '';
      position: absolute;
      width: 15px;
      height: 15px;
      background-color: #329cd944;
      box-shadow: 0 0 20px #329cd9, 0 0 20px #329cd9;
      z-index: 0;
      left: calc(50% - 8px);
      top: calc(50% - 8px);
    }
    & > svg {
      z-index: 1;
    }
  }
`;

const SettingsPanel = ({ settings }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const dayFilters = settings?.dayFilters;
  const enabled = settings?.enabled;
  const tabContents = useMemo(
    () => ({
      calendar: dayFilters ? <PanelWorkingDays settings={settings} enabled={enabled} /> : <></>,
      time: dayFilters ? <PanelWorkingHours settings={settings} enabled={enabled} /> : <></>,
      add: dayFilters ? <PanelExtraTime settings={settings} enabled={enabled} /> : <></>,
    }),
    [dayFilters, settings, enabled],
  );

  return (
    <Pane background="#1F2021" position="relative" display="flex" flex={1} height="100%" flexDirection="column">
      <h2 style={{ textAlign: 'center', color: 'white', fontSize: 20, fontWeight: 900 }}>Settings</h2>

      <Tablist background="#1F2021" height="72px" display="flex" justifyContent="center">
        {tabs.map((tab, index) => {
          return (
            <StyledTab
              key={tab}
              id={tab}
              onSelect={() => setSelectedIndex(index)}
              isSelected={index === selectedIndex}
              aria-controls={`panel-${tab}`}
              flex="1"
              height="100%"
              marginRight="0!important"
            >
              <Icon icon={icon[tab]} size={24} />
            </StyledTab>
          );
        })}
      </Tablist>
      <Pane flex="1">
        {tabs.map((tab, index) => (
          <Pane
            key={tab}
            id={`panel-${tab}`}
            role="tabpanel"
            aria-labelledby={tab}
            aria-hidden={index !== selectedIndex}
            display={index === selectedIndex ? 'block' : 'none'}
          >
            {tabContents[tab]}
          </Pane>
        ))}
      </Pane>
    </Pane>
  );
};

export default SettingsPanel;
